<template>
<div class="card">
  <div class="card-header">
    <h4 class="card-title"><i class="ti-list"></i> Ações</h4>
  </div>
  <div class="card-content">
    <div class="row">
      <div class="col-xs-12">
        <div
          v-if="$can('surveys.associate')"
          class="row"
        >
          <div class=" col-lg-8 col-xs-12">
            <users-options
              ativos="true"
              label="Usuário: "
              @setUser="$emit('setUser', $event)"
            ></users-options>
          </div>
          <div class=" col-lg-4 col-xs-12">
            <button
              :disabled="!enableAssociate"
              @click="$emit('runAssociateAll')"
              class="btn btn-wide btn-fill btn-primary"
            >
              Associar
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <p>
              <strong>Pesquisar:</strong>
              <span v-for="(type, index) in event.surveysType" :key="index">
                  {{ surveysOptions[type] }}{{ index < event.surveysType.length ? ',' : '.' }}
              </span>
            </p>
          </div>
        </div>
        <div
          v-if="$can('surveys.associated.tickets.print')"
          class="row"
        >
          <div class="col-xs-12">
            <button
              type="button"
              class="btn btn-wide btn-fill btn-info"
              @click="printList()"
              style="width: 100%;"
            >
              Abrir lista de clientes associados
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import UsersOptions from 'src/components/UsersOptions'
import {mapGetters} from 'vuex'

export default {
  name: 'survey-actions',

  components: {
    UsersOptions
  },

  props: {
    enableAssociate: {
      default: false
    },

    event: {
      default: ''
    }
  },

  computed: {
    ...mapGetters('events', ['surveysOptions']),
    eventId: function () {
      return this.event._id
    }
  },

  methods: {
    printList () {
      let routeData = this.$router.resolve({
        name: 'surveys.associated.tickets.print',
        params: { id: this.eventId }
      })
      window.open(
        routeData.href,
        'associated-tickets-print',
        'menubar=false,location=false,resizable=false,scrollbars=1,status=false'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveyActions.vue